// extracted by mini-css-extract-plugin
export default {"modalOverlay":"wA-z","modalContent":"xA-z","header":"yA-z","close":"zA-z"};